import { render, staticRenderFns } from "./Sentinela.vue?vue&type=template&id=2dc32304&scoped=true&"
import script from "./Sentinela.vue?vue&type=script&lang=ts&"
export * from "./Sentinela.vue?vue&type=script&lang=ts&"
import style0 from "./sentinela.scss?vue&type=style&index=0&id=2dc32304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc32304",
  null
  
)

export default component.exports